import { ofType } from "redux-observable";
import { mapTo, take } from "rxjs/operators";
import { TypeActionApp } from "../../app/actionApp";
import { actionTrackingSendDesktopDeviceInformation } from "../actionGameTracking";
export var epicGameTrackingDesktopDeviceInformation = function (action$) {
    return action$.pipe(ofType(TypeActionApp.Init), take(1), mapTo(actionTrackingSendDesktopDeviceInformation()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/desktop-device-information/epicGameTrackingDesktopDeviceInformation.ts
// module id = 1860
// module chunks = 3